import CircleCheckSvg from '@assets/images/svg/circle-check.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleCheckIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function CircleCheckIcon({ size = 24, color = '#388E3C', strokeWidth = 2 }: CircleCheckIconProps) {
  return (
    <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
      <CircleCheckSvg width={size} height={size} color={color} strokeWidth={strokeWidth} />
    </View>
  );
}

export default CircleCheckIcon;